var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCategories = function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.975 5.3a.675.675 0 1 0 0 1.35.675.675 0 0 0 0-1.35m6.13 2.12L8.32 3.63A.45.45 0 0 0 8 3.5H3.95a.45.45 0 0 0-.45.45V8a.45.45 0 0 0 .13.32l3.79 3.785a1.35 1.35 0 0 0 1.908 0l2.777-2.754a1.35 1.35 0 0 0 0-1.908zm-.634 1.27-2.782 2.776a.45.45 0 0 1-.634 0L4.4 7.816V4.4h3.416l3.655 3.655a.45.45 0 0 1 0 .634"
  })));
};
export { SvgCategories as ReactComponent };
export default __webpack_public_path__ + "98f82c571756202795fa2b18147d239c.svg";